let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("19P2f")).then(() => parcelRequire('8nTzb'));